/**
 * Vue-related feature flags composable
 * Manages local settings-driven flags and LiteGraph integration
 */
import { createSharedComposable } from '@vueuse/core'
import { computed, watch } from 'vue'

import { LiteGraph } from '../lib/litegraph/src/litegraph'

function useVueFeatureFlagsIndividual() {
  // MiniFlow: Nodes 2.0 is mandatory — always render Vue nodes regardless of settings
  const shouldRenderVueNodes = computed(() => true)

  // Watch for changes and update LiteGraph immediately
  watch(
    shouldRenderVueNodes,
    () => {
      LiteGraph.vueNodesMode = shouldRenderVueNodes.value
    },
    { immediate: true }
  )

  return {
    shouldRenderVueNodes
  }
}

export const useVueFeatureFlags = createSharedComposable(
  useVueFeatureFlagsIndividual
)
